import React, { createContext, useMemo } from 'react';
import { useStorage } from '../storage/useStorage';
export const Context = createContext(undefined);
Context.displayName = 'StoreSessionContext';
const baseInitialState = {
    currency: {
        code: 'USD',
        symbol: '$',
    },
    country: 'USA',
    locale: 'en',
    postalCode: null,
    channel: null,
    person: null,
};
export const SessionProvider = ({ children, initialState, namespace = 'main', }) => {
    const [session, setSession] = useStorage(`${namespace}::store::session`, () => ({
        ...baseInitialState,
        ...initialState,
    }));
    const value = useMemo(() => ({
        ...session,
        setSession: (data) => setSession({ ...session, ...data }),
    }), [session, setSession]);
    return React.createElement(Context.Provider, { value: value }, children);
};
//# sourceMappingURL=Session.js.map